import { SMSSignIn } from "./components/SMSSignIn";
import { MainHeader } from "./components/MainHeader";

export function SignIn() {
  return (
    <>
      <MainHeader title="Sign in" />
      <SMSSignIn />
    </>
  );
}
